import { useState, useEffect } from 'react';
import { Modal, Button, Form, Table, Spinner } from 'react-bootstrap';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

const API_URL = 'https://iron.nextriking.com/api/alias'; 

const PaymentOptions = () => {
  const navigate = useNavigate();
  const [aliasList, setAliasList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingAlias, setEditingAlias] = useState(null);
  const [name, setName] = useState('');
  const [valor, setValor] = useState('');
  const [habilitado, setHabilitado] = useState(true);

  useEffect(() => {
    fetchAlias();
  }, []);

 const fetchAlias = async () => {
  try {
    setLoading(true);
    const response = await axios.get(API_URL);

    if (Array.isArray(response.data)) {
      setAliasList(response.data);
    } else {
      console.warn('La data recibida no es un array:', response.data);
      setAliasList([]);
    }
  } catch (error) {
    console.error('Error al obtener alias:', error);
    Swal.fire('Error', 'No se pudieron cargar los alias', 'error');
  } finally {
    setLoading(false);
  }
};


  const handleOpenModal = (alias = null) => {
  if (alias) {
    setEditingAlias(alias);
    setName(alias.name); 
    setValor(alias.valor);
    setHabilitado(alias.habilitado);
  } else {
    setEditingAlias(null);
    setValor('');
    setHabilitado(true);
    setName(''); 
  }
  setShowModal(true);
};


  const handleCloseModal = () => setShowModal(false);

  const handleSave = async () => {
    if (!valor.trim()) return;

    try {
      if (editingAlias) {
        await axios.put(`${API_URL}/${editingAlias.id}`, {
          name,
          valor,
          habilitado,
        });
        Swal.fire('Actualizado', 'Alias actualizado correctamente', 'success');
      } else {
        await axios.post(API_URL, {
          name,
          valor,
          habilitado,
        });
        Swal.fire('Agregado', 'Alias agregado correctamente', 'success');
      }
      await fetchAlias();
      handleCloseModal();
    } catch (error) {
      console.error('Error al guardar alias:', error);
      Swal.fire('Error', 'No se pudo guardar el alias', 'error');
    }
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Esta acción eliminará el alias.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`${API_URL}/${id}`);
          await fetchAlias();
          Swal.fire('Eliminado', 'Alias eliminado correctamente', 'success');
        } catch (error) {
          console.error('Error al eliminar alias:', error);
          Swal.fire('Error', 'No se pudo eliminar el alias', 'error');
        }
      }
    });
  };

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    navigate('/dashboard');
  };

  return (
    <div className="container py-4">
      <Button variant="secondary" onClick={handleBack} className="mb-3">
        Volver atras
      </Button>
      <h2>Administrar Alias</h2>
      <Button variant="primary" onClick={() => handleOpenModal()} className="mb-3">
        Agregar Alias
      </Button>

      {loading ? (
        <Spinner animation="border" />
      ) : (
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Medio de pago</th>
              <th>Alias</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {aliasList.map(alias => (
              <tr key={alias.id}>
                <td>{alias.name}</td>
                <td>{alias.valor}</td>
                <td>{alias.habilitado ? 'Habilitado' : 'Deshabilitado'}</td>
                <td>
                  <Button variant="warning" size="sm" onClick={() => handleOpenModal(alias)} className="me-2">
                    Editar
                  </Button>
                  <Button variant="danger" size="sm" onClick={() => handleDelete(alias.id)}>
                    Eliminar
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{editingAlias ? 'Editar Alias' : 'Agregar Alias'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Medio de pago</Form.Label>
              <Form.Control
                type="text"
                placeholder="Ingrese un nombre"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>VALOR o alias destino - cuenta receptora</Form.Label>
              <Form.Control
                type="text"
                placeholder="Ingrese un nombre"
                value={valor}
                onChange={(e) => setValor(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Check
                type="checkbox"
                label="Habilitado"
                checked={habilitado}
                onChange={(e) => setHabilitado(e.target.checked)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleSave}>
            {editingAlias ? 'Guardar cambios' : 'Agregar'}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default PaymentOptions;
